import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const getDataCallHistoryReport = async (values) => {
    const res = await axios.post(`${API_URL}call-history-report/data-statistics`, values);
    return res;
};

export const getCallHistoryGraphical = async (values) => {
    const res = await axios.post(`${API_URL}call-history-report/graphical-statistics`, values);
    return res;
};

export const getDuLieuBaoCao = async (values) => {
    const res = await axios.post(`${API_URL}call-history-report/report-export`, values);
    return res?.data;
};
